import React from 'react';

const ImageGuidelinesSection = () => {
    const imageCardClass =
        "rounded-md sm:rounded-lg overflow-hidden shadow-md sm:shadow-lg w-full max-w-[150px] sm:max-w-[190px] md:max-w-[220px] mx-auto";
    const imageAspectStyle = { aspectRatio: '3/5' };

    return (
        <section className="py-20 px-6 bg-[#FFF5F2]">
            <div className="max-w-screen-xl mx-auto">
                <div className="text-center mb-12">
                    <p className="text-sm uppercase tracking-[0.3em] text-[#E85D44] mb-4">
                        IMAGE GUIDELINES
                    </p>
                    <h2 className="text-4xl md:text-5xl font-serif text-gray-900 mb-6">
                        Make It Yours (Image Requirements)
                    </h2>
                </div>

                {/* Qualified Pictures Section */}
                <div className="mb-3 sm:mb-4">
                    <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Qualified Picture:</h3>
                    <div className="grid grid-cols-3 gap-2 sm:gap-3 md:gap-4 max-w-2xl mx-auto">
                        {/* Qualified Image 1 - Very small portrait */}
                        <div className={imageCardClass}>
                            <div className="relative w-full" style={imageAspectStyle}>
                                <img
                                    src="/images/qualified-01.png"
                                    alt="Qualified example 1"
                                    className="w-full h-full object-cover"
                                    loading="lazy"
                                />
                                <div className="absolute top-1 sm:top-2 right-1 sm:right-2 bg-green-500 rounded-full p-1 sm:p-1.5 shadow-md">
                                    <svg className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        {/* Qualified Image 2 - Small portrait */}
                        <div className={imageCardClass}>
                            <div className="relative w-full" style={imageAspectStyle}>
                                <img
                                    src="/images/qualified-02.png"
                                    alt="Qualified example 2"
                                    className="w-full h-full object-cover"
                                    loading="lazy"
                                />
                                <div className="absolute top-1 sm:top-2 right-1 sm:right-2 bg-green-500 rounded-full p-1 sm:p-1.5 shadow-md">
                                    <svg className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        {/* Qualified Image 3 - Small portrait */}
                        <div className={imageCardClass}>
                            <div className="relative w-full" style={imageAspectStyle}>
                                <img
                                    src="/images/qualified-03.png"
                                    alt="Qualified example 3"
                                    className="w-full h-full object-cover"
                                    loading="lazy"
                                />
                                <div className="absolute top-1 sm:top-2 right-1 sm:right-2 bg-green-500 rounded-full p-1 sm:p-1.5 shadow-md">
                                    <svg className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Unqualified Pictures Section */}
                <div>
                    <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Unqualified Picture:</h3>
                    <div className="grid grid-cols-3 gap-2 sm:gap-3 md:gap-4 max-w-2xl mx-auto">
                        {/* Unqualified Image 1 - Very small portrait */}
                        <div className={imageCardClass}>
                            <div className="relative w-full" style={imageAspectStyle}>
                                <img
                                    src="/images/unqualified-01.png"
                                    alt="Unqualified example 1"
                                    className="w-full h-full object-cover"
                                    loading="lazy"
                                />
                                <div className="absolute top-1 sm:top-2 right-1 sm:right-2 bg-red-600 rounded-full p-1 sm:p-1.5 shadow-md">
                                    <svg className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </div>
                                <div className="absolute bottom-0 left-0 right-0 bg-black/80 p-1 sm:p-1.5">
                                    <p className="text-white text-[8px] sm:text-[10px] md:text-xs font-semibold text-center">Portrait is incomplete</p>
                                </div>
                            </div>
                        </div>

                        {/* Unqualified Image 2 - Very small portrait */}
                        <div className={imageCardClass}>
                            <div className="relative w-full" style={imageAspectStyle}>
                                <img
                                    src="/images/unqualified-02.png"
                                    alt="Unqualified example 2"
                                    className="w-full h-full object-cover"
                                    loading="lazy"
                                />
                                <div className="absolute top-1 sm:top-2 right-1 sm:right-2 bg-red-600 rounded-full p-1 sm:p-1.5 shadow-md">
                                    <svg className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </div>
                                <div className="absolute bottom-0 left-0 right-0 bg-black/80 p-1 sm:p-1.5">
                                    <p className="text-white text-[8px] sm:text-[10px] md:text-xs font-semibold text-center">The Proportion of characters is too small</p>
                                </div>
                            </div>
                        </div>

                        {/* Unqualified Image 3 - Very small portrait */}
                        <div className={imageCardClass}>
                            <div className="relative w-full" style={imageAspectStyle}>
                                <img
                                    src="/images/unqualified-03.png"
                                    alt="Unqualified example 3"
                                    className="w-full h-full object-cover"
                                    loading="lazy"
                                />
                                <div className="absolute top-1 sm:top-2 right-1 sm:right-2 bg-red-600 rounded-full p-1 sm:p-1.5 shadow-md">
                                    <svg className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </div>
                                <div className="absolute bottom-0 left-0 right-0 bg-black/80 p-1 sm:p-1.5">
                                    <p className="text-white text-[8px] sm:text-[10px] md:text-xs font-semibold text-center">Unclear Picture or faces cropped</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ImageGuidelinesSection;
